import Filter from './filter';

ZoneObject.create('[data-section-speaker]', {
    run: () => {
        items.create({
            name: 'speaker',
            first_load: true,
            data: Filter,
            glueUnions: true,
            html: (html, data) => {
                html.find('[html="name"]').html(data.name.replace(/ /g, "\n"));

                return html;
            }
        });

        $(document)
            .on('change', '[data-speaker] [name]', () => {
                items.update('speaker');
            })
            .on('click', '[data-chat-user-id]', (e) => {
                var user_id = $(e.currentTarget).attr('data-chat-user-id'),
                    ChatUser = new UserClass({ id: user_id });

                ChatUser.getChatUrl((url) => {
                    location.href = url;
                });
            });
    }
});